<template>
  <div>
    <section-title content="Lugar de Servicio" :has-line="true" />
    <div class="py-4 px-5">
      <div class="d-flex align-items-center">
        <em class="fas fa-arrow-alt-circle-right color-orange font-18" />
        <span class="color-gray-7 font-16 font-weight-bold ml-2">
          Dirección de Localización Principal
        </span>
      </div>
      <div class="row px-4 py-1 py-md-4">
        <div class="col-12 col-lg-4 mt-4 mt-md-0">
          <span class="color-gray-6 d-block font-14">Dirección (Línea 1):</span>
          <span class="font-16 color-black">
            {{ locationInfo.addressLine1 | empty }}
          </span>
        </div>
        <div class="col-12 col-lg-4 mt-4 mt-md-0">
          <span class="color-gray-6 d-block font-14">Dirección (Línea 2):</span>
          <span class="font-16 color-black">
            {{ locationInfo.addressLine2 | empty }}
          </span>
        </div>
        <div class="col-12 col-lg-4 mt-4 mt-md-0">
          <span class="color-gray-6 d-block font-14">Dirección (Línea 3):</span>
          <span class="font-16 color-black">
            {{ locationInfo.addressLine3 | empty }}
          </span>
        </div>
        <div class="col-12 col-lg-4 mt-4">
          <span class="color-gray-6 d-block font-14">Municipio:</span>
          <span class="font-16 color-black">
            {{ locationInfo.municipalityName | empty }}
          </span>
        </div>
        <div class="col-12 col-lg-4 mt-4">
          <span class="color-gray-6 d-block font-14">Estado:</span>
          <span class="font-16 color-black">
            {{ locationInfo.state | empty }}
          </span>
        </div>
        <div class="col-12 col-lg-4 mt-4">
          <span class="color-gray-6 d-block font-14">Código Postal:</span>
          <span class="font-16 color-black">
            {{ locationInfo.postalCode | empty }}
          </span>
        </div>
      </div>
    </div>
    <div class="px-5">
      <div class="d-flex align-items-center mb-3">
        <em class="fas fa-arrow-alt-circle-right color-orange font-18" />
        <span class="color-gray-7 font-16 font-weight-bold ml-2">
          Información donde se ofrecerá el servicio
        </span>
      </div>
      <div class="row px-4 py-1 py-md-3">
        <div class="col-md-4">
          <label class="data-title mb-0">Tipo de Lugar:</label>
          <validation-provider
            v-if="!isReadOnly"
            v-slot="{ errors }"
            name="specialistLocationType"
            rules="required"
          >
            <custom-drop-down
              id="ddlLocationType"
              v-model="model.locationType"
              :clearable="false"
              custom-error-msg="El tipo de lugar es requerido."
              :disabled="isReadOnly"
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              :options="locationTypes"
              placeholder="Seleccione"
              @input="onChangeLocationTypeHandler"
            />
          </validation-provider>
          <span v-else class="d-block font-16 color-black mb-3">
            {{ locationTypeName | empty }}
          </span>
        </div>
        <div class="col-md-4">
          <label class="data-title mb-0">Municipio:</label>
          <validation-provider
            v-if="!isReadOnly"
            v-slot="{ errors }"
            name="specialistMunicipality"
            rules="required"
          >
            <custom-drop-down
              id="ddlMunicipality"
              v-model="model.municipality"
              custom-error-msg="El municipio es requerido."
              :disabled="!model.locationType || isReadOnly"
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              :options="municipalities"
              placeholder="Seleccione"
              @input="onChangeMunicipalityHandler"
            />
          </validation-provider>
          <span v-else class="d-block font-16 color-black mb-3">
            {{ municipalityName | empty }}
          </span>
        </div>
        <div class="col-md-4">
          <label class="data-title mb-0">Lugar de Servicio:</label>
          <validation-provider
            v-if="!isReadOnly"
            v-slot="{ errors }"
            name="specialistLocationService"
            rules="required"
          >
            <custom-drop-down
              id="ddlLocationService"
              v-model="model.locationService"
              custom-error-msg="El lugar de servicio es requerido."
              :disabled="!model.municipality || isReadOnly"
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              :options="locations"
              placeholder="Seleccione"
              @input="onChangeLocationServiceHandler"
            />
          </validation-provider>
          <span v-else class="d-block font-16 color-black mb-3">
            {{ locationServiceName | empty }}
          </span>
        </div>
        <div class="col-md-4 mt-3 mb-3">
          <span class="color-gray-6 d-block font-14">Dirección (Línea 1):</span>
          <validation-provider
            v-if="isHomeLocationType && !isReadOnly"
            v-slot="{ errors }"
            rules="required"
          >
            <custom-input
              id="destinyAddressLine1"
              v-model="locationInfo.destinyAddressLine1"
              custom-error-msg="La dirección (línea 1) es requerida"
              :error="errors[0]"
            />
          </validation-provider>
          <span v-else class="font-16 color-black">
            {{ locationInfo.destinyAddressLine1 | empty }}
          </span>
        </div>
        <div class="col-md-4 mt-3">
          <span class="color-gray-6 d-block font-14">Dirección (Línea 2):</span>
          <custom-input
            v-if="isHomeLocationType && !isReadOnly"
            id="destinyAddressLine2"
            v-model="locationInfo.destinyAddressLine2"
          />
          <span v-else class="font-16 color-black">
            {{ locationInfo.destinyAddressLine2 | empty }}
          </span>
        </div>
        <div class="col-md-4 mt-3">
          <span class="color-gray-6 d-block font-14">Dirección (Línea 3):</span>
          <custom-input
            v-if="isHomeLocationType && !isReadOnly"
            id="destinyAddressLine2"
            v-model="locationInfo.destinyAddressLine3"
          />
          <span v-else class="font-16 color-black">
            {{ locationInfo.destinyAddressLine3 | empty }}
          </span>
        </div>
        <div class="col-md-4">
          <span class="color-gray-6 d-block font-14">Municipio:</span>
          <span
            v-if="isHomeLocationType && !isReadOnly"
            class="font-16 color-black"
          >
            {{ locationInfoMunicipalityName | empty }}
          </span>
          <span v-else class="font-16 color-black">
            {{ locationInfo.destinyMunicipalityName | empty }}
          </span>
        </div>
        <div class="col-md-4">
          <span class="color-gray-6 d-block font-14">Estado:</span>
          <span class="font-16 color-black">
            {{ locationInfo.destinyAddressState | empty }}
          </span>
        </div>
        <div class="col-md-4">
          <span class="color-gray-6 d-block font-14">Código Postal:</span>
          <validation-provider
            v-if="isHomeLocationType && !isReadOnly"
            v-slot="{ errors }"
            rules="required"
          >
            <custom-input
              id="destinyAddressZipCode"
              v-model="locationInfo.destinyAddressZipCode"
              custom-error-msg="El código postal es requerido."
              :error="errors[0]"
            />
          </validation-provider>
          <span v-else class="font-16 color-black">
            {{ locationInfo.destinyAddressZipCode | empty }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//libs components
import { ValidationProvider } from 'vee-validate';
import SectionTitle from 'SectionTitle';
import CustomDropDown from 'custom-drop-down';
import CustomInput from 'CustomInput';

//constants
import codeLocationTypes from '@/utils/constants/codeLocationTypes.js';

export default {
  name: 'LocationInfo',
  components: {
    ValidationProvider,
    SectionTitle,
    CustomDropDown,
    CustomInput,
  },
  props: {
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    locationInfo: {
      type: Object,
      default: () => {},
    },
    locationTypes: {
      type: Array,
      default: () => {},
    },
    municipalities: {
      type: Array,
      default: () => {},
    },
    locations: {
      type: Array,
      default: () => {},
    },
  },
  watch: {
    locationInfo: {
      deep: true,
      immediate: true,
      handler(newVal) {
        this.model = newVal;
        if (this.model.municipality) {
          this.matchLocation(this.model.municipality);
        }
      },
    },
  },
  data: () => ({
    catalog: {
      municipalities: [],
      locationServices: [],
    },
    model: {
      locationType: null,
      municipality: null,
      locationService: null,
    },
  }),
  computed: {
    isHomeLocationType() {
      return (
        this.model.locationType?.id === codeLocationTypes.Home &&
        this.model.locationService?.id
      );
    },
    locationInfoMunicipalityName() {
      return this.locationInfo.municipality?.name;
    },
    locationTypeName() {
      return this.locationInfo?.locationType?.name;
    },
    municipalityName() {
      return this.locationInfo?.municipality?.name;
    },
    locationServiceName() {
      return this.locationInfo?.locationService?.name;
    },
  },
  methods: {
    onChangeLocationTypeHandler(value) {
      this.model.municipality = null;
      this.model.locationService = null;
      this.locationInfo.model = {
        ...this.locationInfo.model,
        locationType: value,
      };
      this.$emit('on-change-location-type', value);
    },
    onChangeMunicipalityHandler(value) {
      this.model.locationService = null;
      this.locationInfo.model = {
        ...this.locationInfo.model,
        municipality: value,
      };

      if (value) {
        this.matchLocation(value);
      }
      this.$emit('on-change-municipality', {
        locationType: this.model.locationType,
        municipality: value,
      });
    },
    onChangeLocationServiceHandler(value) {
      this.locationInfo.model = {
        ...this.locationInfo.model,
        locationService: value,
      };
      this.$emit('on-change-location', value);
    },
    matchLocation({ id }) {
      const locationTypes = [codeLocationTypes.Home, codeLocationTypes.School];
      if (locationTypes.includes(this.locationInfo.locationType.id)) {
        if (this.locationInfo.municipalityId === id) {
          this.$emit('match-location', true);
          return;
        }
        this.$emit('match-location', false);
      }
    },
  },
};
</script>
